/**
 * 监听dom元素是否出现，如果出现则返回该元素，否则等待一段时间后返回null
 * @selector {string} 要等待的元素选择器
 * @timeoutDuration {number} 超时时间，单位毫秒，默认10秒
 * @intervalDuration {number} 检查间隔时间，单位毫秒，默认1秒
 */
function waitForElement(selector, timeoutDuration = 10000, intervalDuration = 1000) {
  return new Promise((resolve, reject) => {
    const targetElement = document.querySelector(selector);

    if (targetElement) {
      resolve(targetElement);
      return;
    }

    const observer = new MutationObserver(() => {
      const targetElement = document.querySelector(selector);
      if (targetElement) {
        observer.disconnect();  // 停止观察
        clearTimeout(timeout);   // 清除超时
        resolve(targetElement);
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });

    const timeout = setTimeout(() => {
      observer.disconnect();  // 超时后停止观察
      reject(new Error(`Timeout: Element ${selector} was not found within ${timeoutDuration}ms.`));
    }, timeoutDuration);

    // 作为备用策略，如果 MutationObserver 无法检测到，可以使用 setInterval
    const checkInterval = setInterval(() => {
      const targetElement = document.querySelector(selector);
      if (targetElement) {
        clearInterval(checkInterval);
        clearTimeout(timeout);   // 清除超时
        observer.disconnect();   // 停止观察
        resolve(targetElement);
      }
    }, intervalDuration);
  });
}
